import { useState, useCallback } from 'react';
import { Button } from 'react-bootstrap';

import usePrivileges from '../../../Auth/usePrivileges';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpDown } from '@fortawesome/free-solid-svg-icons';
import { useSelectGradeDialog } from '../../../Dialogs/SelectGradeDialog';
import CommentDialog from '../../../Dialogs/CommentDialog';
import { useHttpUtils } from '../../../Utilities/useHttpUtils';
import useAlert from '../../../Alerts/useAlert';

export interface ChangeGradeButtonProps {
    lotNumber: string,
    businessUnitCode: string,
    getLotDetail: () => void
}

function ChangeGradeButton({ lotNumber, businessUnitCode, getLotDetail }: ChangeGradeButtonProps) {

    const { canGrade } = usePrivileges(businessUnitCode);
    const { show: showSelectGradeDialog, SelectGradeDialog } = useSelectGradeDialog();
    const [showCommentDialog, setShowCommentDialog] = useState(false);
    const { fetchDataAuthenticated } = useHttpUtils();
    const { setAlert } = useAlert();
    const [newGrade, setNewGrade] = useState<string | null>(null);
        
    const onSave = useCallback((selectedGrade: string | null) => {

        setNewGrade(selectedGrade);
        setShowCommentDialog(true);
    }, []);

    const changeLotGradeWithComment = async (comment: string) => {

        let body = {
            grade: newGrade,
            comment: comment
        };

        fetchDataAuthenticated(`api/v1/lot/grade/${lotNumber}`, "PUT", JSON.stringify(body))
            .then(response => {
                if (response.ok) {
                    setAlert("success", "Success", "Lot grade was changed successfully. Package type set to default package type for this grade.");
                    getLotDetail();
                } else {
                    throw new Error("Failed to change lot grade.");
                }
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            });
    };

    return (
        <>
            <Button variant="light" className="ms-2"
                hidden={!canGrade}
                onClick={() => showSelectGradeDialog()}>
                <FontAwesomeIcon icon={faUpDown} />
            </Button>
            <SelectGradeDialog businessUnitCode={businessUnitCode} lotNumber={lotNumber} onClose={onSave} splitStartUtc={null} splitEndUtc={null} qualities={null} />
            <CommentDialog showDialog={showCommentDialog} closeDialog={() => setShowCommentDialog(false)} onSave={changeLotGradeWithComment} />
        </>
    );
}

export default ChangeGradeButton;